import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step.description;

export const getDescription = ({ step: { details }, t }) => {
  switch (details?.inputValueSource?.type) {
    case 'context_entity_field':
    case 'related_object_field':
    case 'automation_entity_variable_field':
      return t('Transcribe Audio from ‘{{fieldName}}’ field', {
        fieldName: details.inputValueSource.field?.label ?? t('File'),
      });
    case 'automation_variable':
      return t('Transcribe Audio from ‘{{fieldName}}’ variable', {
        fieldName: details.inputValueSource.variable?.label ?? t('File'),
      });
    default:
      return t('Transcribe Audio from ‘File’');
  }
};

export default function AudioTranscriptionCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
